<div
  class="search-box"
  [ngClass]="{
    container: addButton == true && paging != null && paging.totalElements == 0
  }"
  style="height: auto !important"
  [style.display]="modalIsOpen == true ? '' : 'none'"
  [style.right]="this.right"
>
  <!-- [style.width.px]="width"
  [style.top.px]="top"
  [style.left.px]="left" -->
  <!-- [style.left.px]="leftTriangle" -->
  <div class="triangle-up" [style.left]="this.leftTriangle"></div>
  <div class="row">
    <div
      [style.display]="
        addButton == false || paging == null || paging.totalElements > 0
          ? ''
          : 'none'
      "
    >
      <app-pctable
        [data]="data"
        [tdClassInput]="'p-0 px-2'"
        [urlName]="urlName"
        [entityField]="fields"
        (parentAction)="insideTableAction($event)"
      ></app-pctable>
      <app-pcpaging
        [paging]="paging"
        (parentAction)="insideTableAction($event)"
      >
      </app-pcpaging>
    </div>
    <div
      [style.display]="
        addButton == false || paging == null || paging.totalElements > 0
          ? 'none'
          : ''
      "
    >
      <div class="col-12 py-3 d-grid">
        <button
          type="button"
          class="btn btn-outline-primary"
          (click)="addEvent()"
        >
          <i class="fas fa-plus"></i>
          {{ "AddDrugTitle" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
